import { Text, useTheme } from '@simplywallst/ui-core';

import { isIncompleteManualPortfolio } from '@/components/PortfolioManual/utils';

import type { Portfolio } from '@/hooks/usePortfolio';

import { Warning, WarningIcon, StyledGrid } from './styled';

interface Props {
  holdings: Portfolio['holdings'];
  onClick: () => void;
}

export const ManualPortfolioHoldingCompletition = ({
  holdings,
  onClick,
}: Props) => {
  const theme = useTheme();
  const { incompleteHoldingCount } = isIncompleteManualPortfolio(holdings);

  if (incompleteHoldingCount === 0) return null;

  if (incompleteHoldingCount === holdings.length) {
    return (
      <StyledGrid
        templateColumns="26px max-content"
        alignItems="center"
        justifyContent="center"
        justifyContentLg="start"
      >
        <Warning>
          <WarningIcon fill={theme.color.warning} />
        </Warning>
        <button onClick={onClick}>
          <Text typography="tiny" color="brand01">
            Add missing holding details to see returns
          </Text>
        </button>
      </StyledGrid>
    );
  }

  return (
    <StyledGrid
      templateColumns="26px max-content"
      alignItems="center"
      justifyContent="center"
      justifyContentLg="start"
    >
      <Warning>
        <WarningIcon fill={theme.color.warning} />
      </Warning>
      <span>
        <Text as="span" typography="tiny">
          {incompleteHoldingCount}/{holdings.length} holdings are missing data.
        </Text>
        {` `}
        <button onClick={onClick}>
          <Text typography="tiny" color="brand01">
            Add
          </Text>
        </button>
      </span>
    </StyledGrid>
  );
};
